module.exports = __webpack_public_path__ + "static/media/features_img.21330c43.png";